export function cadastroPostoInRequest(params = {}) {
  return {
    type: '@cadastroposto/CADASTROPOSTO_IN_REQUEST',
    payload: { params },
  };
}

export function findCadastroPosto(poco_codigo) {
  return {
    type: '@cadastroposto/FIND_CADASTROPOSTO',
    payload: { poco_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@cadastroposto/FAILED_REQUEST',
  };
}

export function deleteCadastroPosto(poco_codigo, params) {
  return {
    type: '@cadastroposto/DELETE_CADASTROPOSTO',
    payload: { poco_codigo, params },
  };
}

export function updateCadastroPosto(cadastroposto, params) {
  return {
    type: '@cadastroposto/UPDATE_CADASTROPOSTO',
    payload: { cadastroposto, params },
  };
}

export function storeCadastroPosto(cadastroposto, params) {
  return {
    type: '@cadastroposto/STORE_CADASTROPOSTO',
    payload: { cadastroposto, params },
  };
}

export function successInRequest(
  cadastroposto,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@cadastroposto/SUCCESS_IN_REQUEST',
    payload: { cadastroposto, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(cadastroposto) {
  return {
    type: '@cadastroposto/SUCCESS_REQUEST',
    payload: { cadastroposto },
  };
}

export function successRemove(params) {
  return {
    type: '@cadastroposto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@cadastroposto/RECORD_FILTERING',
    payload: { params },
  };
}
